<script setup>
import {ref, defineProps, defineEmits, onMounted} from "vue";
import SearchAutocomplete from "@/components/Base/SearchAutocomplete.vue";
import axios from "axios";
import { useLocationStore } from '@/stores/locationStore'
const locationStore = useLocationStore()

const props = defineProps({
	labelCountry: {
		default: "Выберите страну"
	},
	countryKey: {
		default: 'country'
	},
	modelValue: {
		default: ''
	},
	isFieldRequired: {
		default: false,
		type: Boolean
	},
	//Данные обновляются в родительском компоненте
	isDataUpdating: {}
})

const emit = defineEmits(['onChange','update:modelValue'])

let columns = ref([
	{
		title: 'Страна',
		dataIndex: 'name',
		key: 'name',
	},
	{
		title: 'Действия',
		dataIndex: 'action',
		key: 'action',
	},
])
let countries_list = ref([]);
let countryField = ref('');

async function get_countries_list() {
	await locationStore.fetchCountries()
}
onMounted(async ()=>{
	countryField.value = props.modelValue
	await get_countries_list();
})

function countryChange() {
	emit('update:modelValue', countryField.value)
	emit('onChange');
}
function isFieldRequired(key) {
	return false
}

</script>

<template>
    <div class="location_selector" v-if="countries_list && countries_list.length > 0">
        <div class="country__wrapper" >
            <SearchAutocomplete
                    :items="countries_list"
                    :label="labelCountry"
                    ref="predpolCountryAutocomlete"
                    v-model="countryField"
										:is-required="isFieldRequired"
                    :objectKey="countryKey"
                    :isDataUpdating="isDataUpdating"
                    @onChange="countryChange"
            ></SearchAutocomplete>
        </div>
    </div>
</template>


<style></style>